/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { ApproveTimesheetRequest } from '../models';
import { BooleanResponse } from '../models';
import { LeaveEntryRequest } from '../models';
import { RequestWithAdvanceFilter } from '../models';
import { TimeEntryApprovalViewIEnumerableResponse } from '../models';
import { TimeEntryApprovalViewResponse } from '../models';
import { TimeEntryDateRangeRequest } from '../models';
import { TimeEntryDateRangeRequest2 } from '../models';
import { TimeEntryExportViewIEnumerableResponse } from '../models';
import { TimeEntryFilterRequest } from '../models';
import { TimeEntryRequest } from '../models';
import { TimeEntryViewIEnumerableResponse } from '../models';
import { TimeEntryViewResponse } from '../models';
import { TimesheetDataExportViewIEnumerableResponse } from '../models';
import { TimesheetRequest } from '../models';
import { TrustTeamMemberTimeEntryFilterRequest } from '../models';
import { TrustTeamMemberTimesheetRequest } from '../models';
import { TrustTeamMemberTimesheetRequest2 } from '../models';
/**
 * TimeEntryApi - axios parameter creator
 * @export
 */
export const TimeEntryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA All | Approve Time Entries
         * @param {ApproveTimesheetRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryApproveTimeEntriesPost: async (body?: ApproveTimesheetRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TimeEntry/ApproveTimeEntries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Time Entries by TrustTeamMemberId
         * @param {TrustTeamMemberTimeEntryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryExportTimeEntriesByTrustTeamMemberIdPost: async (body?: TrustTeamMemberTimeEntryFilterRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TimeEntry/ExportTimeEntriesByTrustTeamMemberId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Time Entries
         * @param {TimeEntryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryExportTimeEntriesPost: async (body?: TimeEntryFilterRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TimeEntry/ExportTimeEntries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Timesheet Data by investigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryExportTimesheetDataByInvestigationIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2TimeEntryExportTimesheetDataByInvestigationIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/TimeEntry/ExportTimesheetDataByInvestigationId/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Time Entries by TrustTeamMemberId
         * @param {TimeEntryDateRangeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryGetTimeEntriesByTrustTeamMemberIdPost: async (body?: TimeEntryDateRangeRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TimeEntry/GetTimeEntriesByTrustTeamMemberId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Time Entries
         * @param {RequestWithAdvanceFilter} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryGetTimeEntriesPost: async (body?: RequestWithAdvanceFilter, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TimeEntry/GetTimeEntries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Timesheet Approval by TrustTeamMemberId
         * @param {TrustTeamMemberTimesheetRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryGetTimeEntryApprovalByTrustTeamMemberIdPost: async (body?: TrustTeamMemberTimesheetRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TimeEntry/GetTimeEntryApprovalByTrustTeamMemberId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Timesheet Approvals
         * @param {TimesheetRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryGetTimeEntryApprovalsPost: async (body?: TimesheetRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TimeEntry/GetTimeEntryApprovals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Time Entry by TimeEntryId
         * @param {number} timeEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryGetTimeEntryByIdTimeEntryIdGet: async (timeEntryId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeEntryId' is not null or undefined
            if (timeEntryId === null || timeEntryId === undefined) {
                throw new RequiredError('timeEntryId','Required parameter timeEntryId was null or undefined when calling apiV2TimeEntryGetTimeEntryByIdTimeEntryIdGet.');
            }
            const localVarPath = `/api/v2/TimeEntry/GetTimeEntryById/{timeEntryId}`
                .replace(`{${"timeEntryId"}}`, encodeURIComponent(String(timeEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Delete Time Entry
         * @param {number} timeEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryTrustInvestigatorDeleteTimeEntryTimeEntryIdDelete: async (timeEntryId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeEntryId' is not null or undefined
            if (timeEntryId === null || timeEntryId === undefined) {
                throw new RequiredError('timeEntryId','Required parameter timeEntryId was null or undefined when calling apiV2TimeEntryTrustInvestigatorDeleteTimeEntryTimeEntryIdDelete.');
            }
            const localVarPath = `/api/v2/TimeEntry/TrustInvestigator/DeleteTimeEntry/{timeEntryId}`
                .replace(`{${"timeEntryId"}}`, encodeURIComponent(String(timeEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Time Entries by ExternalId
         * @param {TimeEntryDateRangeRequest2} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryTrustInvestigatorGetTimeEntriesByExternalIdPost: async (body?: TimeEntryDateRangeRequest2, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TimeEntry/TrustInvestigator/GetTimeEntriesByExternalId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Timesheet Approval by ExternalId
         * @param {TrustTeamMemberTimesheetRequest2} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryTrustInvestigatorGetTimeEntryApprovalByExternalIdPost: async (body?: TrustTeamMemberTimesheetRequest2, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TimeEntry/TrustInvestigator/GetTimeEntryApprovalByExternalId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Save Leave Time Entry
         * @param {LeaveEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryTrustInvestigatorSaveLeaveTimeEntryPost: async (body?: LeaveEntryRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TimeEntry/TrustInvestigator/SaveLeaveTimeEntry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Save Time Entry
         * @param {TimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryTrustInvestigatorSaveTimeEntryPost: async (body?: TimeEntryRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TimeEntry/TrustInvestigator/SaveTimeEntry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TimeEntryApi - functional programming interface
 * @export
 */
export const TimeEntryApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA All | Approve Time Entries
         * @param {ApproveTimesheetRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryApproveTimeEntriesPost(body?: ApproveTimesheetRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryApproveTimeEntriesPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Time Entries by TrustTeamMemberId
         * @param {TrustTeamMemberTimeEntryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryExportTimeEntriesByTrustTeamMemberIdPost(body?: TrustTeamMemberTimeEntryFilterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryViewIEnumerableResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryExportTimeEntriesByTrustTeamMemberIdPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Time Entries
         * @param {TimeEntryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryExportTimeEntriesPost(body?: TimeEntryFilterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryExportViewIEnumerableResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryExportTimeEntriesPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Timesheet Data by investigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryExportTimesheetDataByInvestigationIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimesheetDataExportViewIEnumerableResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryExportTimesheetDataByInvestigationIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Time Entries by TrustTeamMemberId
         * @param {TimeEntryDateRangeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryGetTimeEntriesByTrustTeamMemberIdPost(body?: TimeEntryDateRangeRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryViewIEnumerableResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryGetTimeEntriesByTrustTeamMemberIdPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Time Entries
         * @param {RequestWithAdvanceFilter} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryGetTimeEntriesPost(body?: RequestWithAdvanceFilter, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryViewIEnumerableResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryGetTimeEntriesPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Timesheet Approval by TrustTeamMemberId
         * @param {TrustTeamMemberTimesheetRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryGetTimeEntryApprovalByTrustTeamMemberIdPost(body?: TrustTeamMemberTimesheetRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryApprovalViewResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryGetTimeEntryApprovalByTrustTeamMemberIdPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Timesheet Approvals
         * @param {TimesheetRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryGetTimeEntryApprovalsPost(body?: TimesheetRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryApprovalViewIEnumerableResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryGetTimeEntryApprovalsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Time Entry by TimeEntryId
         * @param {number} timeEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryGetTimeEntryByIdTimeEntryIdGet(timeEntryId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryViewResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryGetTimeEntryByIdTimeEntryIdGet(timeEntryId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Delete Time Entry
         * @param {number} timeEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryTrustInvestigatorDeleteTimeEntryTimeEntryIdDelete(timeEntryId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryTrustInvestigatorDeleteTimeEntryTimeEntryIdDelete(timeEntryId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Time Entries by ExternalId
         * @param {TimeEntryDateRangeRequest2} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryTrustInvestigatorGetTimeEntriesByExternalIdPost(body?: TimeEntryDateRangeRequest2, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryViewIEnumerableResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryTrustInvestigatorGetTimeEntriesByExternalIdPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Timesheet Approval by ExternalId
         * @param {TrustTeamMemberTimesheetRequest2} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryTrustInvestigatorGetTimeEntryApprovalByExternalIdPost(body?: TrustTeamMemberTimesheetRequest2, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryApprovalViewResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryTrustInvestigatorGetTimeEntryApprovalByExternalIdPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Save Leave Time Entry
         * @param {LeaveEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryTrustInvestigatorSaveLeaveTimeEntryPost(body?: LeaveEntryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryTrustInvestigatorSaveLeaveTimeEntryPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Save Time Entry
         * @param {TimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryTrustInvestigatorSaveTimeEntryPost(body?: TimeEntryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryTrustInvestigatorSaveTimeEntryPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TimeEntryApi - factory interface
 * @export
 */
export const TimeEntryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary TA All | Approve Time Entries
         * @param {ApproveTimesheetRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryApproveTimeEntriesPost(body?: ApproveTimesheetRequest, options?: any): AxiosPromise<BooleanResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryApproveTimeEntriesPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Time Entries by TrustTeamMemberId
         * @param {TrustTeamMemberTimeEntryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryExportTimeEntriesByTrustTeamMemberIdPost(body?: TrustTeamMemberTimeEntryFilterRequest, options?: any): AxiosPromise<TimeEntryViewIEnumerableResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryExportTimeEntriesByTrustTeamMemberIdPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Time Entries
         * @param {TimeEntryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryExportTimeEntriesPost(body?: TimeEntryFilterRequest, options?: any): AxiosPromise<TimeEntryExportViewIEnumerableResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryExportTimeEntriesPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Timesheet Data by investigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryExportTimesheetDataByInvestigationIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<TimesheetDataExportViewIEnumerableResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryExportTimesheetDataByInvestigationIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Time Entries by TrustTeamMemberId
         * @param {TimeEntryDateRangeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryGetTimeEntriesByTrustTeamMemberIdPost(body?: TimeEntryDateRangeRequest, options?: any): AxiosPromise<TimeEntryViewIEnumerableResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryGetTimeEntriesByTrustTeamMemberIdPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Time Entries
         * @param {RequestWithAdvanceFilter} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryGetTimeEntriesPost(body?: RequestWithAdvanceFilter, options?: any): AxiosPromise<TimeEntryViewIEnumerableResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryGetTimeEntriesPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Timesheet Approval by TrustTeamMemberId
         * @param {TrustTeamMemberTimesheetRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryGetTimeEntryApprovalByTrustTeamMemberIdPost(body?: TrustTeamMemberTimesheetRequest, options?: any): AxiosPromise<TimeEntryApprovalViewResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryGetTimeEntryApprovalByTrustTeamMemberIdPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Timesheet Approvals
         * @param {TimesheetRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryGetTimeEntryApprovalsPost(body?: TimesheetRequest, options?: any): AxiosPromise<TimeEntryApprovalViewIEnumerableResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryGetTimeEntryApprovalsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Time Entry by TimeEntryId
         * @param {number} timeEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryGetTimeEntryByIdTimeEntryIdGet(timeEntryId: number, options?: any): AxiosPromise<TimeEntryViewResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryGetTimeEntryByIdTimeEntryIdGet(timeEntryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Delete Time Entry
         * @param {number} timeEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryTrustInvestigatorDeleteTimeEntryTimeEntryIdDelete(timeEntryId: number, options?: any): AxiosPromise<BooleanResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryTrustInvestigatorDeleteTimeEntryTimeEntryIdDelete(timeEntryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Time Entries by ExternalId
         * @param {TimeEntryDateRangeRequest2} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryTrustInvestigatorGetTimeEntriesByExternalIdPost(body?: TimeEntryDateRangeRequest2, options?: any): AxiosPromise<TimeEntryViewIEnumerableResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryTrustInvestigatorGetTimeEntriesByExternalIdPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Timesheet Approval by ExternalId
         * @param {TrustTeamMemberTimesheetRequest2} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryTrustInvestigatorGetTimeEntryApprovalByExternalIdPost(body?: TrustTeamMemberTimesheetRequest2, options?: any): AxiosPromise<TimeEntryApprovalViewResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryTrustInvestigatorGetTimeEntryApprovalByExternalIdPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Save Leave Time Entry
         * @param {LeaveEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryTrustInvestigatorSaveLeaveTimeEntryPost(body?: LeaveEntryRequest, options?: any): AxiosPromise<BooleanResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryTrustInvestigatorSaveLeaveTimeEntryPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Save Time Entry
         * @param {TimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryTrustInvestigatorSaveTimeEntryPost(body?: TimeEntryRequest, options?: any): AxiosPromise<BooleanResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryTrustInvestigatorSaveTimeEntryPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TimeEntryApi - object-oriented interface
 * @export
 * @class TimeEntryApi
 * @extends {BaseAPI}
 */
export class TimeEntryApi extends BaseAPI {
    /**
     * 
     * @summary TA All | Approve Time Entries
     * @param {ApproveTimesheetRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryApproveTimeEntriesPost(body?: ApproveTimesheetRequest, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryApproveTimeEntriesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Time Entries by TrustTeamMemberId
     * @param {TrustTeamMemberTimeEntryFilterRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryExportTimeEntriesByTrustTeamMemberIdPost(body?: TrustTeamMemberTimeEntryFilterRequest, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryExportTimeEntriesByTrustTeamMemberIdPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Time Entries
     * @param {TimeEntryFilterRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryExportTimeEntriesPost(body?: TimeEntryFilterRequest, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryExportTimeEntriesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Timesheet Data by investigationId
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryExportTimesheetDataByInvestigationIdInvestigationIdGet(investigationId: number, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryExportTimesheetDataByInvestigationIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Time Entries by TrustTeamMemberId
     * @param {TimeEntryDateRangeRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryGetTimeEntriesByTrustTeamMemberIdPost(body?: TimeEntryDateRangeRequest, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryGetTimeEntriesByTrustTeamMemberIdPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Time Entries
     * @param {RequestWithAdvanceFilter} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryGetTimeEntriesPost(body?: RequestWithAdvanceFilter, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryGetTimeEntriesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Timesheet Approval by TrustTeamMemberId
     * @param {TrustTeamMemberTimesheetRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryGetTimeEntryApprovalByTrustTeamMemberIdPost(body?: TrustTeamMemberTimesheetRequest, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryGetTimeEntryApprovalByTrustTeamMemberIdPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Timesheet Approvals
     * @param {TimesheetRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryGetTimeEntryApprovalsPost(body?: TimesheetRequest, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryGetTimeEntryApprovalsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Time Entry by TimeEntryId
     * @param {number} timeEntryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryGetTimeEntryByIdTimeEntryIdGet(timeEntryId: number, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryGetTimeEntryByIdTimeEntryIdGet(timeEntryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Delete Time Entry
     * @param {number} timeEntryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryTrustInvestigatorDeleteTimeEntryTimeEntryIdDelete(timeEntryId: number, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryTrustInvestigatorDeleteTimeEntryTimeEntryIdDelete(timeEntryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Returns Time Entries by ExternalId
     * @param {TimeEntryDateRangeRequest2} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryTrustInvestigatorGetTimeEntriesByExternalIdPost(body?: TimeEntryDateRangeRequest2, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryTrustInvestigatorGetTimeEntriesByExternalIdPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Returns Timesheet Approval by ExternalId
     * @param {TrustTeamMemberTimesheetRequest2} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryTrustInvestigatorGetTimeEntryApprovalByExternalIdPost(body?: TrustTeamMemberTimesheetRequest2, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryTrustInvestigatorGetTimeEntryApprovalByExternalIdPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Save Leave Time Entry
     * @param {LeaveEntryRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryTrustInvestigatorSaveLeaveTimeEntryPost(body?: LeaveEntryRequest, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryTrustInvestigatorSaveLeaveTimeEntryPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Save Time Entry
     * @param {TimeEntryRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryTrustInvestigatorSaveTimeEntryPost(body?: TimeEntryRequest, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryTrustInvestigatorSaveTimeEntryPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
